import { accept, create, get, getAll, remove, update } from "api/proposal";

import { createDeal } from "./deal";

export const getProposal = (token) => ({
  type: "PROPOSAL_GET",
  payload: get(token),
});

export const acceptProposal = (token, params) => ({
  type: "PROPOSAL_ACCEPT",
  payload: accept(token, params),
});

export const getProposals = (dealID) => ({
  type: "PROPOSALS_GET",
  payload: getAll(dealID),
  meta: { dealID },
});

export const deleteProposal = (proposalID) => ({
  type: "PROPOSAL_DELETE",
  payload: remove(proposalID),
  meta: { proposalID },
});

export const createProposal = (proposal) => ({
  type: "PROPOSAL_CREATE",
  payload: create(proposal),
});

export const createProposalWithDeal = (proposal) => (dispatch) => {
  if (proposal.deal.id) {
    return dispatch({
      type: "PROPOSAL_CREATE",
      payload: create(proposal),
    });
  }

  return dispatch(
    createDeal(
      {
        ...proposal.deal,
        assetId: proposal.asset && proposal.asset.id,
        shareStatus: proposal.shareStatus,
        _brokers: proposal["_brokers"], // eslint-disable-line
      },
      proposal.portfolio.id
    )
  ).then((res) =>
    dispatch({
      type: "PROPOSAL_CREATE",
      payload: create({ ...proposal, deal: { id: res.value.deal.id } }),
    })
  );
};

export const saveProposal = (proposal) => (dispatch) => {
  if (proposal.id) {
    return dispatch({
      type: "PROPOSAL_SAVE",
      payload: update(proposal),
      meta: { proposalID: proposal.id },
    });
  }

  return dispatch(createProposal(proposal));
};
